import { useEffect } from 'react';

const LiveChat = ({ locale = null, me, direction = 'ltr', hideChatButton = false }) => {
    const initChat = () => {
        if (window.fcWidget) {
            window.fcWidget.init({
                token: process.env.REACT_APP_LIVE_CHAT_TOKEN,
                host: 'https://wchat.freshchat.com',
                config: {
                    headerProperty: {
                        direction,
                        hideChatButton,
                    },
                },
                ...getUserDetails(),
            });
        }
    };
    const getUserDetails = () => {
        if (me) {
            let lang;
            if (locale) {
                lang = locale.language;
            }
            else if (me) {
                lang = (me.locale_preferred || me.locale).language;
            }
            return {
                externalId: String(me.id),
                firstName: me.first_name,
                lastName: me.last_name,
                email: me.email,
                locale: lang,
            };
        }
        else {
            return null;
        }
    };
    useEffect(() => {
        if (window.fcWidget && window.fcWidget.isLoaded()) {
            return;
        }
        const script = window.document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://wchat.freshchat.com/js/widget.js';
        script.onload = initChat;
        window.document.head.appendChild(script);
        return () => {
            window.document.head.removeChild(script);
            delete window.fcWidget;
        };
    }, []);
    useEffect(() => {
        if (!window.fcWidget) {
            return;
        }
        const details = getUserDetails();
        if (details) {
            window.fcWidget.setExternalId(details.externalId);
            window.fcWidget.user.setProperties(details);
        }
    }, [locale, me]);
    return null;
};
const openLiveChat = () => {
    if (!window.fcWidget) {
        return;
    }
    window.fcWidget.open();
};

export { LiveChat, openLiveChat };
